<template>
    <div class="exchage_index">
        <div class="exchage_index_header">
            <Swipe
                :loop="false"
                :show-indicators="false"
                width="100%"
                height="100%"
            >
                <SwipeItem v-for="(item,index) in bannerList" :key="index">
                <VanImage :src="item.imgurl" fit="cover" width="100%" height="100%">
                    <template v-slot:loading>
                    <loading type="spinner" size="20" />
                    </template>
                    <template v-slot:error>加载失败</template>
                </VanImage>
                </SwipeItem>
            </Swipe>
            <!-- <UserCard></UserCard> -->
        </div>
        <div class="exchage_index_body">
            <CategoryList v-if="categorysList.length" :categorysList="categorysList"></CategoryList>
            <van-skeleton title  :row="2" :animate="false" v-else/>
        </div>
    </div>
</template>
<script>
    import './index.less'
    import UserCard from '@/views/User/UserCard'
    import CategoryList from '@/views/Exchange/Category'
    import { Swipe, SwipeItem, Loading, Image } from "vant";
    export default {
        name:"exchangeindex",
        data(){
          return {
              categorysList:[],
              scroll:0,
              bannerList: [
                  {
                      imgurl: "https://oss.mcloud.moveclub.cn/alphamovecloud/20220327/1648367797/1648367830020/组 2550.jpg?x-oss-process=image/crop,x_0,y_0,w_750,h_376"
                  }
              ]
          }
        },
        components:{
            VanImage: Image,
            Loading,
            UserCard,
            Swipe,
            SwipeItem,
            CategoryList
        },
        methods:{
            getGoodsList(){
                this.$api.exchange.goodsList().then((res)=>{
                    if(res.status*1===200){
                        this.categorysList  =   res.data
                    }

                })
            },
            getbanner() {
                this.$api.common.getBanners({position:14}).then((res)=>{
                    this.bannerList =  res.data
                })
            }
        },
        mounted(){
            this.$nextTick(()=>{
                // this.getbanner()
                this.getGoodsList();
            })
        }
    }
</script>
